import dynamic from 'next/dynamic';

const TeaserPromotion = dynamic(() =>
  import('@components/molecules/TeaserPromotion/TeaserPromotion').then((module) => module.TeaserPromotion),
);

export const PageContentElementEntityAd = (element) => {
  if (!element) return null;
  return <TeaserPromotion {...element} />;
};

export default PageContentElementEntityAd;
